import { useState } from "react";
import { Mail, Send, Users, TrendingUp, BookOpen, Heart, Paperclip, ChevronRight, Briefcase, FileText, UserCheck } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* ── dati reali + arricchimento editoriale ── */
const VALORI = [
  {
    id: "impatto",
    icon: Users,
    titolo: "Impatto concreto",
    testo:
      "Ogni giorno il tuo lavoro supporta migliaia di imprese del commercio, del turismo e dei servizi. Fai parte di una rete che muove l'economia di Roma e del territorio.",
  },
  {
    id: "crescita",
    icon: TrendingUp,
    titolo: "Crescita professionale",
    testo:
      "Accedi a programmi di formazione continua, workshop specialistici e percorsi di sviluppo interno. Investiamo nelle persone perché sono la nostra risorsa principale.",
  },
  {
    id: "formazione",
    icon: BookOpen,
    titolo: "Ambiente stimolante",
    testo:
      "Collabora con professionisti di settori diversi — legale, economico, comunicazione, welfare — in un contesto dinamico che favorisce l'innovazione e il confronto.",
  },
  {
    id: "wellbeing",
    icon: Heart,
    titolo: "Benessere e tutele",
    testo:
      "Offriamo un contratto stabile, flessibilità organizzativa, welfare aziendale e un ambiente inclusivo in cui valorizzare le competenze di ciascuno.",
  },
];

const PROCESSO = [
  {
    step: "01",
    icon: FileText,
    titolo: "Invia il tuo CV",
    testo: "Manda il tuo curriculum all'indirizzo dedicato con una breve lettera di presentazione.",
  },
  {
    step: "02",
    icon: UserCheck,
    titolo: "Primo contatto",
    testo: "Il team Risorse Umane esamina le candidature e contatta i profili più in linea entro 30 giorni.",
  },
  {
    step: "03",
    icon: Briefcase,
    titolo: "Colloquio",
    testo: "Un colloquio conoscitivo per capire le tue aspirazioni e presentarti il contesto di lavoro.",
  },
];

export default function LavoraConNoiPage() {
  const [form, setForm] = useState({ nome: "", email: "", ruolo: "", messaggio: "" });
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, { ...form, oggetto: `Candidatura spontanea - ${form.ruolo || "non specificato"}` });
      setStatus("success");
      setForm({ nome: "", email: "", ruolo: "", messaggio: "" });
      setFile(null);
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main id="main-content" data-testid="lavora-con-noi-page">

      {/* ── Hero ── */}
      <section className="relative h-[320px] md:h-[380px] overflow-hidden" aria-labelledby="lavora-title">
        <img
          src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?w=1920&q=60&auto=format"
          alt="Team Confcommercio Roma"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4,30,66,0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">
            Unisciti al team
          </span>
          <h1
            id="lavora-title"
            className="text-4xl md:text-5xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight"
          >
            Lavora con noi
          </h1>
          <p className="mt-3 text-white/70 text-base max-w-xl">
            Entra a far parte di una delle principali organizzazioni di rappresentanza delle imprese del territorio romano.
          </p>
        </div>
      </section>

      {/* ── Candidatura spontanea ── */}
      <section id="candidatura" className="py-14 bg-white" aria-labelledby="candidatura-title">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
            <span
              className="font-['Encode_Sans_Semi_Condensed']"
              style={{
                fontSize: "0.72rem",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.18em",
                color: "var(--confcom-blue)",
                display: "block",
                marginBottom: "0.5rem",
              }}
            >
              Candidatura spontanea
            </span>
            <h2
              id="candidatura-title"
              className="text-2xl md:text-3xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-3"
            >
              Il tuo profilo ci interessa
            </h2>
            <p className="text-[var(--confcom-text-secondary)] text-base max-w-xl mx-auto">
              Invia la tua candidatura spontanea: la valuteremo con attenzione per opportunità in <strong>Confcommercio Roma</strong>, <strong>Promo.Ter</strong> e <strong>C.A.T.</strong>
            </p>
          </div>

          {/* Card email diretta */}
          <div
            style={{
              background: "linear-gradient(135deg, #003580 0%, #0052A3 100%)",
              borderRadius: "1.25rem",
              padding: "2rem 2.5rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1.5rem",
              flexWrap: "wrap",
              marginBottom: "2rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Mail size={22} color="#fff" />
              </div>
              <div>
                <p style={{ color: "rgba(255,255,255,0.70)", fontSize: "0.78rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em" }}>
                  Email selezione del personale
                </p>
                <a
                  href="mailto:selezione@confcommercioroma.it"
                  data-testid="email-selezione"
                  className="font-['Encode_Sans_Semi_Condensed']"
                  style={{ color: "#fff", fontSize: "1.2rem", fontWeight: 700, textDecoration: "none" }}
                >
                  selezione@confcommercioroma.it
                </a>
              </div>
            </div>
            <a
              href="mailto:selezione@confcommercioroma.it"
              style={{
                background: "#fff",
                color: "var(--confcom-blue)",
                fontWeight: 700,
                fontSize: "0.88rem",
                padding: "0.65rem 1.5rem",
                borderRadius: "0.5rem",
                textDecoration: "none",
                flexShrink: 0,
                display: "inline-flex",
                alignItems: "center",
                gap: "0.4rem",
              }}
            >
              Scrivi ora <ChevronRight size={15} />
            </a>
          </div>

          {/* Form candidatura */}
          <div
            style={{
              background: "#F5F8FC",
              border: "1px solid var(--confcom-border)",
              borderRadius: "1.25rem",
              padding: "2.5rem",
            }}
          >
            <h3
              className="font-['Encode_Sans_Semi_Condensed']"
              style={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--confcom-text-primary)", marginBottom: "1.5rem" }}
            >
              Oppure compila il modulo
            </h3>

            <form onSubmit={handleSubmit} data-testid="candidatura-form" noValidate>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "1.25rem",
                  marginBottom: "1.25rem",
                }}
              >
                <div>
                  <label htmlFor="cn-nome" className="block text-sm font-medium text-[var(--confcom-text-primary)] mb-1.5">
                    Nome e Cognome *
                  </label>
                  <input
                    id="cn-nome"
                    type="text"
                    required
                    value={form.nome}
                    onChange={(e) => setForm({ ...form, nome: e.target.value })}
                    className="w-full h-11 px-4 border border-[var(--confcom-border)] rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[var(--confcom-blue)] text-sm"
                    data-testid="cn-nome"
                  />
                </div>
                <div>
                  <label htmlFor="cn-email" className="block text-sm font-medium text-[var(--confcom-text-primary)] mb-1.5">
                    Email *
                  </label>
                  <input
                    id="cn-email"
                    type="email"
                    required
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className="w-full h-11 px-4 border border-[var(--confcom-border)] rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[var(--confcom-blue)] text-sm"
                    data-testid="cn-email"
                  />
                </div>
              </div>

              <div style={{ marginBottom: "1.25rem" }}>
                <label htmlFor="cn-ruolo" className="block text-sm font-medium text-[var(--confcom-text-primary)] mb-1.5">
                  Ruolo / Area di interesse
                </label>
                <input
                  id="cn-ruolo"
                  type="text"
                  value={form.ruolo}
                  onChange={(e) => setForm({ ...form, ruolo: e.target.value })}
                  placeholder="es. Consulente del lavoro, Comunicazione, Formazione…"
                  className="w-full h-11 px-4 border border-[var(--confcom-border)] rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[var(--confcom-blue)] text-sm"
                  data-testid="cn-ruolo"
                />
              </div>

              <div style={{ marginBottom: "1.5rem" }}>
                <label htmlFor="cn-messaggio" className="block text-sm font-medium text-[var(--confcom-text-primary)] mb-1.5">
                  Presentati *
                </label>
                <textarea
                  id="cn-messaggio"
                  rows={4}
                  required
                  placeholder="Raccontaci chi sei, le tue esperienze e cosa ti motiva a lavorare con noi…"
                  value={form.messaggio}
                  onChange={(e) => setForm({ ...form, messaggio: e.target.value })}
                  className="w-full px-4 py-3 border border-[var(--confcom-border)] rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[var(--confcom-blue)] text-sm resize-none"
                  data-testid="cn-messaggio"
                />
              </div>

              {/* Upload CV */}
              <div style={{ marginBottom: "1.5rem" }}>
                <label className="block text-sm font-medium text-[var(--confcom-text-primary)] mb-1.5">
                  Allega CV <span className="text-[var(--confcom-text-secondary)] font-normal">(PDF, max 5 MB)</span>
                </label>
                <label
                  htmlFor="cn-cv"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    padding: "0.75rem 1rem",
                    border: "1.5px dashed var(--confcom-border)",
                    borderRadius: "0.5rem",
                    background: file ? "#EBF5FF" : "#fff",
                    cursor: "pointer",
                    transition: "border-color 0.2s, background 0.2s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = "var(--confcom-blue)"}
                  onMouseLeave={e => e.currentTarget.style.borderColor = file ? "var(--confcom-blue)" : "var(--confcom-border)"}
                >
                  <Paperclip size={18} color={file ? "var(--confcom-blue)" : "var(--confcom-text-secondary)"} style={{ flexShrink: 0 }} />
                  <span style={{ fontSize: "0.875rem", color: file ? "var(--confcom-blue)" : "var(--confcom-text-secondary)", fontWeight: file ? 600 : 400 }}>
                    {file ? file.name : "Clicca per caricare il tuo CV…"}
                  </span>
                  {file && (
                    <button
                      type="button"
                      onClick={e => { e.preventDefault(); setFile(null); document.getElementById("cn-cv").value = ""; }}
                      style={{ marginLeft: "auto", fontSize: "0.75rem", color: "var(--confcom-text-secondary)", background: "none", border: "none", cursor: "pointer" }}
                    >
                      Rimuovi
                    </button>
                  )}
                </label>
                <input
                  id="cn-cv"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={e => setFile(e.target.files[0] || null)}
                  style={{ display: "none" }}
                  data-testid="cn-cv"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity disabled:opacity-50"
                data-testid="cn-submit"
              >
                <Send size={18} aria-hidden="true" />
                {loading ? "Invio in corso…" : "Invia candidatura"}
              </button>

              {status === "success" && (
                <div
                  className="p-4 bg-green-50 border border-green-200 rounded-lg text-sm text-green-800"
                  role="alert"
                  data-testid="cn-success"
                  style={{ marginTop: "1rem" }}
                >
                  Candidatura inviata! Ti contatteremo non appena si apre un'opportunità adatta al tuo profilo.
                </div>
              )}
              {status === "error" && (
                <div
                  className="p-4 bg-red-50 border border-red-200 rounded-lg text-sm text-red-800"
                  role="alert"
                  data-testid="cn-error"
                  style={{ marginTop: "1rem" }}
                >
                  Si è verificato un errore. Puoi inviarci direttamente un'email a{" "}
                  <a href="mailto:selezione@confcommercioroma.it" className="underline">
                    selezione@confcommercioroma.it
                  </a>
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}
